import { faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'

import { Blobs, Flex, Spinner } from '../../../App/Components/'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'

import { ProfileAvatar, ProfileHead } from './style'

export const ProfileDashboardHeading = () => {
  const user = useAppSelector(state => state.users.currentUser)

  if (!user) {
    return <Spinner />
  }
  return (
    <>
      <Blobs
        gradient={'linear-gradient(to right, #005aa7, #fffde4)'}
        blobNumber={3}
      />
      <ProfileHead
        flexDirection={'row'}
        container
        justifyContent={'space-between'}
        alignItems={'center'}
        style={{ width: '100%' }}>
        <Flex container alignItems={'center'}>
          <Link to={'/profile'}>
            <ProfileAvatar
              src={`${user.avatar}&w=144&h=144&fit=crop`}
              alt={'User avatar image'}
            />
          </Link>
          <h1 style={{ margin: 0, color: 'white' }}>
            {`${user.firstName || ''} ${user.lastName || ''}`}
          </h1>
          <Link to={'/profile/settings'}>
            <FontAwesomeIcon
              color="white"
              icon={faCog}
              style={{
                marginLeft: '20px',
              }}
            />
          </Link>
        </Flex>
      </ProfileHead>
    </>
  )
}
